import { Component, EventEmitter, Output, Input } from '@angular/core';

export type Direction = 'forward' | 'backward';

export interface SortEvent {
  column: string;
  direction: Direction;
}

@Component({
  selector: 'header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss']
})
export class HeaderComponent {
  @Input()
  sortBackward: boolean;

  // Колонка, по которой осуществляется сортировка
  @Input()
  columnName: string;

  @Input()
  showActiveApp: boolean;

  @Output()
  sorted = new EventEmitter<SortEvent>();

  sort(columnName: string) {
    const direction = !this.sortBackward ? 'backward' : 'forward';
    this.sorted.emit({ column: columnName, direction });
  }
}
